import React from "react";
import Frame from "../shared/Frame";
import { useAccountID } from "../store/account";

export default function EpisodeDetail() {
    const accountID = useAccountID();
    return <Frame src={`/__/${accountID}/reports/episodedetail`} />;
}
